<template>
  <div class="booter">
    <div class="container" style="text-indent: 0;padding-left: 5px;line-height: 150%;font-size: 16px;border-left:0px solid #777;">
      版权所有：江苏和悦医疗科技有限公司
      <div class="icpbox">

        ICP备案号：<a
        class="icp"
        target="_blank"
        href="https://beian.miit.gov.cn/"
        >苏ICP备2024140514号-1</a
        ><br>
        互联网药品信息服务资格备案号：<a
        class="icp"
        target="_blank"
        href="https://beian.miit.gov.cn/"
        >xxxx-xxxxxxxx-xx</a
        >
        
      </div>
      <br>
      地址:江苏省盐城市响水县东海路响水镇农民创业园7# <br />联系人:李经理
      <br />联系电话:18961936699
    </div>
  </div>
</template>

<script>
export default {};

</script>

<style>
.booter {
  background-color: rgba(26, 24, 24, 0.822);
  height: 100px;
  padding: 20px;
  color: white;
  text-align: left;
}
.icpbox{
  float:right;
  text-align:right;
}
a.icp {
  text-decoration: none;
  color: #f2f9ff;
}
body{margin:0}
</style>